<button
	#button
	matRipple
	class="Button"
	[matTooltip]="tooltipLabel()"
	[matTooltipPosition]="tooltipPosition()"
	matTooltipClass="Tooltip"
	[disabled]="disabledInner() || isDisabled()"
	[class.Button--isDisabled]="isDisabled()"
	[class.Button--isFull]="isFull()"
	[class.Button--hasIcon]="hasIcon()"
	[class.Button--isOutline]="isOutline()"
	[class.Button--red]="color() === EButtonColor.red"
	[class.Button--greenOne]="color() === EButtonColor.greenOne"
>
	<ng-content select="appIcon" />
	<ng-content />
</button>
